import { View, Log, Utils } from '../vendor/kerneljs';

const TabPanes = View.extend({

	events: {
		'click .js--primary-tab': 'primaryTabClick',
		'click .js--secondary-tab': 'secondaryTabClick',
		'change .js--primary-nav select': 'primarySelectChange',
		'change .tab-panes__navigation__primary select': 'primarySelectChange',
		'change .js--secondary-nav select': 'secondarySelectChange'
	},

	initialize: function () {
		this.contentPanes = this.find('.js--content');
		this.primaryTabs = this.find('.js--primary-tab');
		this.isMultiLevel = this.el.getAttribute('data-multilevel');

		this.secondaryNavs = this.find('.js--secondary-nav');
		this.secondaryTabs = this.find('.js--secondary-tab');

		this.activePrimaryTab = this.find('.js--primary-tab.is-active');
		this.mobileActiveId = this.el.getAttribute('data-mobileactiveid');

		this.mobileViewport = document.body.clientWidth < 767;

		if ( this.mobileActiveId && this.mobileViewport ) {
			Utils.each(this.secondaryTabs, function(elem) {
				Utils.removeClass(elem,'is-active');
			});
			this.activeSecondaryTab = this.find('.js--secondary-tab[data-contentid="'+this.mobileActiveId+'"]');
			Utils.addClass(this.activeSecondaryTab,'is-active');
			this.selectContent(this.mobileActiveId);
		}

		setTimeout(function () {
			if (this.activePrimaryTab instanceof HTMLElement) {
				this.selectPrimary(this.activePrimaryTab, true);
			}
			else {
				this.selectPrimary(this.primaryTabs[0]);
			}
		}.bind(this), 200);
	},

	primaryTabClick: function (event) {
		let tab = event.currentTarget;
		this.selectPrimary(tab);
	},

	primarySelectChange: function (event) {
		var contentId = event.currentTarget?.selectedOptions?.[0]?.dataset?.contentid;
		this.selectContent(contentId);
	},

	selectPrimary: function (tab, overrideAlreadyActive) {
		if (!(tab instanceof HTMLElement) || (Utils.hasClass(tab, 'is-active') && !overrideAlreadyActive)) return false;
	
		this.deactivateAllPrimaryTabs();
		this.activatePrimaryTab(tab);
	
		if (this.isMultiLevel) {
			this.handleMultiLevelNavigation(tab);
		} else {
			this.selectContentById(tab.getAttribute('data-contentid'));
		}
	},
	
	deactivateAllPrimaryTabs: function() {
		Utils.each(this.primaryTabs, function (elem) {
			Utils.removeClass(elem, 'is-active');
		});
		Utils.each(this.contentPanes, function (elem) {
			Utils.removeClass(elem, 'is-active');
			elem.setAttribute('style', '');
		});
	},
	
	activatePrimaryTab: function(tab) {
		Utils.addClass(tab, 'is-active');
	},
	
	handleMultiLevelNavigation: function(tab) {
		this.deactivateSecondaryNavsAndTabs();
		let secondaryNavId = tab.getAttribute('data-secondarytabid');
	
		if (secondaryNavId) {
			this.activateSecondaryNavAndTab(secondaryNavId);
		}
	},
	
	deactivateSecondaryNavsAndTabs: function() {
		Utils.each(this.secondaryNavs, function (elem) {
			Utils.removeClass(elem, 'is-active');
			elem.setAttribute('style', '');
		});
		Utils.each(this.secondaryTabs, function (elem) {
			Utils.removeClass(elem, 'is-active');
		});
	},
	
	activateSecondaryNavAndTab: function(secondaryNavId) {
		let secondaryNav = this.find('.js--secondary-nav[data-secondarytabid="' + secondaryNavId + '"]')[0];
		if (secondaryNav) {
			secondaryNav.setAttribute('style', 'display:block;');
			setTimeout(() => {
				Utils.addClass(secondaryNav, 'is-active');
			}, 40);
	
			try {
				let currentSecondaryFirstTab = Utils.find(secondaryNav, '.js--secondary-tab')[0];
				Utils.addClass(currentSecondaryFirstTab, 'is-active');
				this.selectContentById(currentSecondaryFirstTab.getAttribute('data-contentid'));
			} catch (error) {
				Log.db("FAILED TO PRESELECT SECONDARY TAB");
			}
		}
	},
	
	selectContentById: function(contentId) {
		this.selectContent(contentId);
	},

	secondaryTabClick: function (event) {
		let tab = event.currentTarget;
		if (Utils.hasClass(tab, 'is-active')) {
			return false;
		} else {
			let contentId = tab.getAttribute('data-contentid');
			Utils.each(this.secondaryTabs, function (elem) {
				Utils.removeClass(elem, 'is-active');
			});
			Utils.addClass(tab, 'is-active');
			this.selectContent(contentId);
		}
	},

	secondarySelectChange: function (event) {
		let formItem = event.target;

		if (formItem.selectedIndex) {
			if ( formItem.options[formItem.selectedIndex] ) {	
				let contentId = formItem.options[formItem.selectedIndex].value;

				this.selectContent(contentId);
			}
		}
	},

	selectContent: function (contentId) {
		if (contentId) {
			Utils.each(this.contentPanes, function (elem) {
				Utils.removeClass(elem, 'is-active');
				elem.setAttribute('style', '');
			});

			let contentPane = this.find('.js--content[data-contentid="' + contentId + '"]');
			contentPane.setAttribute('style', 'display:block;');

			if ( contentPane.dataset.eventname ) this.eventEmitter.emit(contentPane.dataset.eventname);

			setTimeout(() => {
				Utils.addClass(contentPane, 'is-active');
			}, 40);
		}
	}
});

(function () {
	Utils.each(Utils.find('.js--tab-panes'), function (elem) {
		new TabPanes({ el: elem });
	});
})();

export default TabPanes;
